import { render, staticRenderFns } from "./upload_attach_batch.vue?vue&type=template&id=1a590a07&scoped=true"
import script from "./upload_attach_batch.vue?vue&type=script&lang=js"
export * from "./upload_attach_batch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a590a07",
  null
  
)

export default component.exports